import React from "react"
import { Card, CardContent, Typography, CardActions, Chip } from "@mui/material"
import { Event } from "../types"

interface EventCardProps {
  event: Event
}

export const EventCard: React.FC<EventCardProps> = ({ event }) => {
  return (
    <Card sx={{ maxWidth: 345, width: "100%" }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {event.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Description: {event.description}
        </Typography>
        <Typography sx={{ mt: 1.5 }}>
          Start: {new Date(event.startDate).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </Typography>
        <Typography>
          End: {new Date(event.endDate).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </Typography>
        <Chip
          label={event.archiveStatus ? "Archived" : "Active"}
          color={event.archiveStatus ? "secondary" : "primary"}
          sx={{ mt: 1 }}
        />
      </CardContent>
      <CardActions>
        <Typography variant="body2" sx={{ ml: "auto" }}>
          {event.numVoters} Voters
        </Typography>
      </CardActions>
    </Card>
  )
}
